module.exports = __webpack_public_path__ + "static/media/dindle4.4c2703e6.png";